/**
 * Générateur — Automatisme : utiliser le théorème de Thalès dans la
 * configuration des triangles emboîtés pour calculer une longueur.
 * Attendu ID : 1086 | Niveau : 4ème | Domaine : Espace et géométrie, géométrie plane
 * Rubrique : AUTOMATISME (créé par le professeur, gen neuf du 2026-09-24).
 *
 * ── D'où vient l'intitulé ─────────────────────────────────────────────────
 * Le BO 2025 met Thalès en 3e (cycle 4 l. 1104-1105 : « Connaitre et
 * appliquer le théorème de Thalès, sa réciproque, sa contraposée
 * (configurations des triangles emboités et configuration dite du
 * papillon) ») ; le professeur le garde en 4e, comme le découpage de 2019
 * (repères annuels : « 4e : Le théorème de Thalès et sa réciproque dans la
 * configuration des triangles emboîtés sont énoncés et utilisés »). Lignes
 * servies, qui font plafond : Eduscol, attendus de fin de 4e (2019) l. 391
 * (« le théorème de Thalès et sa réciproque dans la configuration des
 * triangles emboîtés ») et l. 277-278 (« Dans le cadre d'un
 * agrandissement-réduction ou dans une configuration de Thalès, il sait
 * calculer une longueur manquante en utilisant la proportionnalité. »).
 * S'il revient au BO, le gen migre tel quel en 3e.
 *
 * ── Cadrage (sous-agent programme-maths 2026-09-24, décisions prof) ───────
 * Le cours du prof (19Thales4 p. 1-2) : « AB'/AB = AC'/AC = B'C'/BC »,
 * petit triangle sur grand triangle, puis les deux rapports utiles et le
 * produit en croix (« 4,5/BE = 3/7, soit BE = 4,5 × 7 : 3 »). Ça tombe
 * juste : k = p/q parmi 1/4, 1/3, 2/5, 1/2, 3/5, 2/3,
 * 3/4, 4/5 ; les côtés du grand triangle sont des multiples de q/2 entre 4
 * et 20, ceux du petit des multiples de p/2 (au plus une décimale, ,5), au
 * moins 1,5. Grand triangle SCALÈNE (AB, AC, BC distincts : l'erreur
 * additive ne tombe jamais juste, elle vaut la clé si et seulement si deux
 * côtés sont égaux) et lisible (angle en A de 30° à 110°, les deux autres
 * d'au moins 25°). Les six longueurs peuvent être cherchées ; la paire
 * donnée entière est l'une des deux autres. Figure EXACTE (décision prof
 * 24/09), longueurs dans l'énoncé, (MN) et (BC) en vert (fiche 1 du prof).
 * CALCULATRICE AUTORISÉE sur les trois cartes de calcul (décision prof 24/09
 * au soir, « n'oublie pas élève de 4e » : 7 × 13,5 ÷ 10,5 ne se fait pas de
 * tête), pas sur « L'égalité de Thalès ». Rappel brouillon IMPÉRATIF sur les
 * quatre formats depuis le 25/09 (prof : « ici faut utiliser un brouillon » ;
 * la règle du 23/09 le pose par attendu, donc partout, QCM d'écriture
 * compris). SACRIFIÉ (fiche à venir) : l'exemple du cours, k = 3/7, hors de
 * la liste des k.
 *
 * ── Révision 2026-09-25 (retour prof, carte par carte) ───────────────────
 *   - Brouillon impératif (RAPPEL_BROUILLON, juste avant la question), sauf
 *     sur « L'égalité de Thalès » où rien ne se calcule (check du soir).
 *   - « Calcule la longueur » et « La longueur cherchée » FUSIONNÉES : une
 *     carte « Calcule la longueur », deux formats (saisie, QCM), mêmes clés.
 *   - « Les étapes du calcul » : la rédaction complète est écrite au-dessus
 *     des lignes à compléter, « On sait que les points … sont alignés … et
 *     que les droites … sont parallèles. Donc, d'après le théorème de
 *     Thalès : » ; les cases restent sur les nombres.
 *
 * ── Cartes ────────────────────────────────────────────────────────────────
 *   « L'égalité de Thalès » (egalite_qcm_unique) : la figure et la
 *     configuration, « Quelle égalité donne le théorème de Thalès ? » ; la
 *     triple égalité du cours contre trois écritures fausses.
 *   « Calcule la longueur », deux formats : saisie (calcul_texte), trois
 *     longueurs, la quatrième à saisir ; QCM (longueur_qcm_unique), le QCM
 *     de classe, la clé contre l'erreur additive (la principale) et les
 *     rapports retournés.
 *   « Les étapes du calcul » (etapes_texte_trou_saisie) : la rédaction (« On
 *     sait que … Donc, d'après le théorème de Thalès : »), la triple égalité
 *     imprimée, les deux rapports utiles avec les nombres en cases (le choix
 *     des homologues), le résultat ; le produit en croix se fait au brouillon
 *     (deux cases autour d'un « × » compteraient faux l'ordre inverse).
 *   Coupées au cadrage (épreuve de Musk) : « Petit triangle, grand
 *   triangle » (drag, le repérage est déjà dans « Les étapes ») et l'ordonner
 *   (la rédaction est celle de 1087) ; les problèmes (Cristo, phare, éclipse,
 *   ombre) demandent calculatrice ou deux étapes : 189.
 *
 * ── Erreurs (familles nommées) ───────────────────────────────────────────
 *   additif (PRINCIPALE) : l'écart est conservé (MN = BC − (AB − AM)) ;
 *     DEPP début de 2de 2025 q.13 : 30,7 % ;
 *   coefficient_inverse : un rapport retourné (DEPP q.13 : 1,6 %) ;
 *   mauvais_homologue : AM associé à AC ;
 *   morceau_pour_le_cote : MB pris pour AB (AM/MB = MN/BC est faux) ;
 *   difference_des_donnees : AB − AM répondu tel quel (DEPP q.13 : 10,1 %).
 *
 * Hors : le papillon et la contraposée (3e) ; un morceau à additionner
 * (AB = AM + MB) et les problèmes à deux étapes (189) ; le coefficient k
 * d'agrandissement (174) ; la réciproque (1087) ; « quel outil ? » (190).
 */
import {
    randInt, randomChoice, shuffle, tex,
    makeQcm, makeSaisie, makeTexteTrou,
} from '../../../utils';
import {
    frDix, tirerLettres, nomsDe, angleEntre, pointsThales, figureThales,
    phraseAlignes, donnee, rapport,
} from './thales';

const ATTENDU_ID = 1086;
const opts = (label) => ({ niveau: '4eme', matiere: 'maths', attendu: ATTENDU_ID, label });

const L_EGALITE = 'L\'égalité de Thalès';
const L_CALCUL = 'Calcule la longueur';
const L_ETAPES = 'Les étapes du calcul';

// Calculatrice AUTORISÉE sur les cartes de calcul (décision prof 2026-09-24 au soir : « n'oublie pas élève de 4e »).
const calculatrice = (payload) => ({ ...payload, contenu: { ...payload.contenu, calculatrice: true } });
// Rappel brouillon (règle prof du 2026-09-23, par attendu ; posé ici le 2026-09-25) : IMPÉRATIF sur
// les quatre formats, juste avant la question.
const RAPPEL_BROUILLON = '<p class="italic text-slate-400">✏️ Pose tes calculs au brouillon.</p>';

/** Les rapports petit / grand, k = p / q. */
export const K = [[1, 4], [1, 3], [2, 5], [1, 2], [3, 5], [2, 3], [3, 4], [4, 5]];
/** Les paires d'homologues, dans l'ordre du cours : petit triangle / grand triangle. */
export const PAIRES = [['AM', 'AB'], ['AN', 'AC'], ['MN', 'BC']];
const range = (a, b) => Array.from({ length: Math.max(0, b - a + 1) }, (_, i) => a + i);

/**
 * Une configuration : k, les six longueurs en dixièmes (grand = n·q·5,
 * petit = n·p·5), grand triangle scalène et lisible, la figure.
 */
export const tirerConfiguration = () => {
    for (let essai = 0; essai < 500; essai++) {
        const [p, q] = randomChoice(K);
        const ns = range(Math.max(Math.ceil(40 / (5 * q)), Math.ceil(15 / (5 * p))), Math.floor(200 / (5 * q)));
        if (ns.length < 3) continue;
        const [n1, n2, n3] = shuffle(ns).slice(0, 3);
        const [AB, AC, BC] = [n1, n2, n3].map((n) => n * q * 5);
        if (AB + AC <= BC || AB + BC <= AC || AC + BC <= AB) continue;
        const alpha = angleEntre(AB, AC, BC);
        if (alpha < 30 || alpha > 110 || angleEntre(AB, BC, AC) < 25 || angleEntre(AC, BC, AB) < 25) continue;
        const d = { AM: n1 * p * 5, AB, AN: n2 * p * 5, AC, MN: n3 * p * 5, BC };
        const L = tirerLettres();
        const pts = pointsThales({ L, AB, AC, alpha, kM: p / q, kN: p / q, deg: randInt(0, 23) * 15, miroir: randInt(0, 1) === 1 });
        return { p, q, d, L, noms: nomsDe(L), figure: figureThales(pts, L, true) };
    }
    throw new Error('gen_1086 : configuration introuvable');
};

/** La longueur cherchée, sa paire, la paire donnée entière et les trois données (ordre de l'énoncé). */
const tirerQuestion = (c, impose = null) => {
    const cherche = impose || randomChoice(['AM', 'AB', 'AN', 'AC', 'MN', 'BC']);
    const iS = PAIRES.findIndex((pr) => pr.includes(cherche));
    const iK = randomChoice([0, 1, 2].filter((i) => i !== iS));
    const partenaire = PAIRES[iS].find((x) => x !== cherche);
    return { cherche, iS, iK, partenaire, donnes: [...PAIRES[iK], partenaire] };
};

const enonce = (c, qn) => {
    const phrase = `<p>${phraseAlignes(c.L)} Les droites ${tex(`(${c.noms.MN})`)} et ${tex(`(${c.noms.BC})`)} sont parallèles.</p>`;
    if (!qn) return phrase;
    const [a, b, d] = qn.donnes.map((k) => donnee(c.noms[k], c.d[k]));
    return `${phrase}<p>On donne ${a}, ${b} et ${d}.</p>`;
};

// ─── Carte « L'égalité de Thalès » (QCM) ───────────────────────────────────

const genEgalite = () => {
    const c = tirerConfiguration(); const n = c.noms;
    const r = (h, b) => rapport(n[h] || h, n[b] || b);
    const MB = c.L.M + c.L.B; const NC = c.L.N + c.L.C;
    const bon = tex(`${r('AM', 'AB')} = ${r('AN', 'AC')} = ${r('MN', 'BC')}`);
    const inverses = [
        tex(`${r('AB', 'AM')} = ${r('AN', 'AC')} = ${r('MN', 'BC')}`),
        tex(`${r('AM', 'AB')} = ${r('AC', 'AN')} = ${r('MN', 'BC')}`),
        tex(`${r('AM', 'AB')} = ${r('AN', 'AC')} = ${r('BC', 'MN')}`),
    ];
    const faux = [
        { v: randomChoice(inverses), code: 'coefficient_inverse' },
        { v: tex(`${r('AM', 'AC')} = ${r('AN', 'AB')} = ${r('MN', 'BC')}`), code: 'mauvais_homologue' },
        { v: tex(`${rapport(n.AM, MB)} = ${rapport(n.AN, NC)} = ${r('MN', 'BC')}`), code: 'morceau_pour_le_cote' },
    ];
    // Pas de rappel brouillon : on choisit une écriture, rien ne se calcule (prof 2026-09-25).
    const texte = enonce(c, null) + '<p><b>Quelle égalité donne le théorème de Thalès ?</b></p>';
    const payload = makeQcm([bon, ...faux.map((f) => f.v)], bon, texte, { ...opts(L_EGALITE), elements_additionnels: c.figure });
    payload._meta.params = { k: `${c.p}/${c.q}`, d: c.d, distracteurs: faux.map(({ code }) => ({ code })) };
    return payload;
};

// ─── Carte « Calcule la longueur » (saisie) ────────────────────────────────

const genCalcul = () => {
    const c = tirerConfiguration(); const qn = tirerQuestion(c);
    const texte = enonce(c, qn) + RAPPEL_BROUILLON + `<p><b>Calcule ${tex(c.noms[qn.cherche])}.</b></p>`;
    const payload = makeSaisie(frDix(c.d[qn.cherche]), texte, { ...opts(L_CALCUL), suffixe: 'cm', elements_additionnels: c.figure });
    payload._meta.params = { k: `${c.p}/${c.q}`, d: c.d, cherche: qn.cherche, donnes: qn.donnes };
    return calculatrice(payload);
};

// ─── Carte « Les étapes du calcul » (saisie guidée) ────────────────────────

const genEtapes = () => {
    const c = tirerConfiguration(); const qn = tirerQuestion(c); const n = c.noms;
    const terme = (k) => (k === qn.cherche ? n[k] : `{{${frDix(c.d[k])}}}`);
    const utiles = [qn.iK, qn.iS].sort((a, b) => a - b);
    // second chemin : le produit en croix redonne la longueur cherchée (en dixièmes)
    const [sK, bK] = PAIRES[qn.iK].map((k) => c.d[k]);
    const x = qn.cherche === PAIRES[qn.iS][0] ? (sK * c.d[qn.partenaire]) / bK : (bK * c.d[qn.partenaire]) / sK;
    if (x !== c.d[qn.cherche]) throw new Error('gen_1086 : produit en croix');
    const lignes = [
        `$${rapport(n.AM, n.AB)} = ${rapport(n.AN, n.AC)} = ${rapport(n.MN, n.BC)}$`,
        `$${utiles.map((i) => rapport(terme(PAIRES[i][0]), terme(PAIRES[i][1]))).join(' = ')}$`,
        `$${n[qn.cherche]} = {{${frDix(c.d[qn.cherche])}}}\\text{ cm}$`,
    ];
    // La rédaction complète (prof 25/09), écrite au-dessus des lignes à compléter :
    // les hypothèses puis le théorème, comme au cours.
    const redaction = `<p>On sait que les points ${tex(c.L.A)}, ${tex(c.L.M)}, ${tex(c.L.B)} sont alignés, que les points ${tex(c.L.A)}, ${tex(c.L.N)}, ${tex(c.L.C)} sont alignés, `
        + `et que les droites ${tex(`(${n.MN})`)} et ${tex(`(${n.BC})`)} sont parallèles. Donc, d'après le théorème de Thalès :</p>`;
    const texte = enonce(c, qn) + RAPPEL_BROUILLON
        + `<p><b>Complète le calcul de ${tex(n[qn.cherche])} : écris les nombres dans les deux rapports utiles, puis le résultat.</b></p>`
        + redaction;
    const payload = makeTexteTrou(lignes.join('\n'), texte, { ...opts(L_ETAPES), mode: 'saisie', elements_additionnels: c.figure });
    payload._meta.params = { k: `${c.p}/${c.q}`, d: c.d, cherche: qn.cherche, donnes: qn.donnes };
    return calculatrice(payload);
};

// ─── Carte « La longueur cherchée » (QCM calculé) ──────────────────────────

/** Les candidats faux, en dixièmes (exacts ou non), nommés. */
const candidatsFaux = (c, qn) => {
    const [sK, bK] = PAIRES[qn.iK].map((k) => c.d[k]);
    const v = c.d[qn.partenaire];
    const petit = qn.cherche === PAIRES[qn.iS][0];
    return petit
        ? [
            { code: 'additif', x: v - (bK - sK) },
            { code: 'coefficient_inverse', x: (bK * v) / sK },
            { code: 'difference_des_donnees', x: bK - sK },
            { code: 'mauvais_homologue', x: (sK * bK) / v },
        ]
        : [
            { code: 'additif', x: v + (bK - sK) },
            { code: 'coefficient_inverse', x: (sK * v) / bK },
            { code: 'difference_des_donnees', x: bK - sK },
            { code: 'mauvais_homologue', x: (sK * bK) / v },
        ];
};
/** Au plus une décimale de plus que les données (centièmes exacts). */
const exactAuCentieme = (x) => Math.abs(x * 10 - Math.round(x * 10)) < 1e-9;
/** Dixièmes (entiers ou au centième) → écriture française, sans zéro inutile. */
const frDixDec = (x) => {
    const h = Math.round(x * 10); const e = Math.trunc(h / 100); const r = h % 100;
    if (r === 0) return String(e);
    return r % 10 === 0 ? `${e},${r / 10}` : `${e},${String(r).padStart(2, '0')}`;
};

const genLongueur = () => {
    // la longueur cherchée d'abord (six à parts égales), puis les nombres jusqu'à ce que la clé soit encadrée
    const impose = randomChoice(['AM', 'AB', 'AN', 'AC', 'MN', 'BC']);
    for (let essai = 0; essai < 200; essai++) {
        const c = tirerConfiguration(); const qn = tirerQuestion(c, impose);
        const cle = c.d[qn.cherche];
        // en centièmes pour tous (la clé comme les candidats) : un faux égal à la clé est écarté
        const vus = new Set([Math.round(cle * 10)]);
        const valides = candidatsFaux(c, qn).filter(({ x }) => {
            if (!(x > 0) || !exactAuCentieme(x) || vus.has(Math.round(x * 10))) return false;
            vus.add(Math.round(x * 10));
            return true;
        });
        if (valides.length < 3) continue;
        // trois faux qui encadrent la clé (un en dessous, un au-dessus) : sinon un nouveau tirage,
        // jusqu'à 100 essais (au-delà, trois faux du même côté plutôt que rien)
        const dessous = valides.filter((f) => f.x < cle); const dessus = valides.filter((f) => f.x > cle);
        if ((!dessous.length || !dessus.length) && essai < 100) continue;
        let choisis;
        if (dessous.length && dessus.length) {
            const a = randomChoice(dessous); const b = randomChoice(dessus);
            choisis = [a, b, randomChoice(valides.filter((f) => f !== a && f !== b))];
        } else choisis = shuffle(valides).slice(0, 3);
        const bon = `${frDix(cle)} cm`;
        const texte = enonce(c, qn) + RAPPEL_BROUILLON + `<p><b>Combien mesure ${tex(c.noms[qn.cherche])} ?</b></p>`;
        const payload = makeQcm([bon, ...choisis.map((f) => `${frDixDec(f.x)} cm`)], bon, texte, { ...opts(L_CALCUL), elements_additionnels: c.figure });
        payload._meta.params = { k: `${c.p}/${c.q}`, d: c.d, cherche: qn.cherche, donnes: qn.donnes, distracteurs: choisis.map(({ code }) => ({ code })) };
        return calculatrice(payload);
    }
    throw new Error('gen_1086 : QCM sans distracteurs');
};

// ─── Contrat distracteurs (référence de revue) ────────────────────────────

export const REGLES_DISTRACTEURS_QCM = {
    invariants_communs: [
        'k parmi K, grand triangle scalène et lisible, longueurs à une décimale au plus, figure exacte, (MN) et (BC) en vert, lettres saines en KaTeX',
    ],
    egalite_qcm_unique: 'la triple égalité du cours contre coefficient_inverse (un rapport retourné), mauvais_homologue (AM/AC = AN/AB, faux car AB ≠ AC), morceau_pour_le_cote (AM/MB = AN/NC = MN/BC, faux : MN/BC = k, AM/MB = k/(1 − k))',
    longueur_qcm_unique: 'additif (PRINCIPALE), coefficient_inverse, difference_des_donnees, mauvais_homologue ; positifs, distincts, au centième exact ; un en dessous et un au-dessus de la clé quand c\'est possible ; sinon nouveau tirage complet',
};

// ─── Registre et point d'entrée ───────────────────────────────────────────

const GENERATORS = {
    egalite_qcm_unique: genEgalite,
    calcul_texte: genCalcul,
    etapes_texte_trou_saisie: genEtapes,
    longueur_qcm_unique: genLongueur,
};

// Trois cartes (fusion du 2026-09-25) : la saisie et le QCM de la longueur cherchée sur la même carte.
export const CATEGORIES = [
    { id: 'egalite', label: L_EGALITE, formatsList: [{ key: 'egalite_qcm_unique', label: 'QCM' }] },
    { id: 'calcul', label: L_CALCUL, formatsList: [{ key: 'calcul_texte', label: 'Saisie' }, { key: 'longueur_qcm_unique', label: 'QCM' }] },
    { id: 'etapes', label: L_ETAPES, formatsList: [{ key: 'etapes_texte_trou_saisie', label: 'Saisie guidée' }] },
];

export const generate = (typeExercice) => {
    let key;
    if (typeExercice && GENERATORS[typeExercice]) key = typeExercice;
    else if (typeExercice) {
        const matching = Object.keys(GENERATORS).filter((k) => k.startsWith(typeExercice) || k.includes(typeExercice));
        key = matching.length ? randomChoice(matching) : randomChoice(Object.keys(GENERATORS));
    } else key = randomChoice(Object.keys(GENERATORS));
    const payload = GENERATORS[key]();
    payload._meta.generatorKey = key;
    return payload;
};
